export default __webpack_public_path__ + "static/31508-e73c74f5a7bde1f953f4e68500199e00.jpg";